import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function AppAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 21, 19);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 21 19"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M7.5 0.5L6.5 5.5M14.5 0.5L13.5 5.5M20.5 5.5H0.5M5.3 18.5H15.7C17.3802 18.5 18.2202 18.5 18.862 18.173C19.4265 17.8854 19.8854 17.4265 20.173 16.862C20.5 16.2202 20.5 15.3802 20.5 13.7V5.3C20.5 3.61984 20.5 2.77976 20.173 2.13803C19.8854 1.57354 19.4265 1.1146 18.862 0.82698C18.2202 0.5 17.3802 0.5 15.7 0.5H5.3C3.61984 0.5 2.77976 0.5 2.13803 0.82698C1.57354 1.1146 1.1146 1.57354 0.82698 2.13803C0.5 2.77976 0.5 3.61984 0.5 5.3V13.7C0.5 15.3802 0.5 16.2202 0.82698 16.862C1.1146 17.4265 1.57354 17.8854 2.13803 18.173C2.77976 18.5 3.61984 18.5 5.3 18.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DialogAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 25, 25);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M10.1 16.1L6.40969 19.8364C5.89494 20.3576 5.63757 20.6182 5.41634 20.6366C5.22442 20.6525 5.0365 20.5754 4.91115 20.4292C4.76667 20.2606 4.76667 19.8944 4.76667 19.1618V17.2899C4.76667 16.6328 4.22849 16.1572 3.57824 16.062C2.00449 15.8315 0.768531 14.5955 0.53801 13.0218C0.5 12.7623 0.5 12.4526 0.5 11.8333V6.26C0.5 4.24381 0.5 3.23572 0.892377 2.46563C1.23752 1.78825 1.78825 1.23752 2.46563 0.892377C3.23572 0.5 4.24381 0.5 6.26 0.5H15.14C17.1562 0.5 18.1643 0.5 18.9344 0.892377C19.6117 1.23752 20.1625 1.78825 20.5076 2.46563C20.9 3.23572 20.9 4.24381 20.9 6.26V11.3M20.9 24.5L18.2883 22.6843C17.9212 22.429 17.7376 22.3014 17.5378 22.2109C17.3605 22.1306 17.1741 22.0722 16.9827 22.0369C16.767 21.9971 16.5434 21.9971 16.0963 21.9971H13.94C12.5959 21.9971 11.9238 21.9971 11.4104 21.7356C10.9588 21.5055 10.5917 21.1383 10.3616 20.6867C10.1 20.1733 10.1 19.5013 10.1 18.1571V15.14C10.1 13.7959 10.1 13.1238 10.3616 12.6104C10.5917 12.1588 10.9588 11.7917 11.4104 11.5616C11.9238 11.3 12.5959 11.3 13.94 11.3H20.66C22.0041 11.3 22.6762 11.3 23.1896 11.5616C23.6412 11.7917 24.0083 12.1588 24.2384 12.6104C24.5 13.1238 24.5 13.7959 24.5 15.14V18.3971C24.5 19.5154 24.5 20.0745 24.3173 20.5156C24.0737 21.1037 23.6065 21.5709 23.0184 21.8145C22.5774 21.9971 22.0183 21.9971 20.9 21.9971V24.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeadphoneAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 22, 29);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 22 29"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M9.0178 24.4675C7.37976 27.5057 12.9491 30.2063 14.5871 27.168M9.0178 24.4675L12.9491 16.0282C9.7752 15.6676 8.31887 15.1043 6.39694 13.3277M9.0178 24.4675L14.5871 27.168M14.5871 27.168L20.4841 13.6652C23.1049 6.57626 20.4841 1.51271 14.5871 0.5C10.9834 0.5 9.02554 1.32902 6.39694 3.20056M6.39694 3.20056V13.3277M6.39694 3.20056C5.41412 1.17522 1.81043 2.18793 0.5 4.21335V11.9775C1.36515 14.5505 6.06933 15.3532 6.39694 13.3277M12.6215 10.2896H15.2424C16.3279 10.2896 17.208 9.38281 17.208 8.2642C17.208 7.14559 16.3279 6.23878 15.2424 6.23878H12.6215C11.5359 6.23878 10.6558 7.14559 10.6558 8.2642C10.6558 9.38281 11.5359 10.2896 12.6215 10.2896Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LetterAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 21, 27);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 21 27"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M13 0.850391V6.22009C13 6.94816 13 7.31219 13.1362 7.59028C13.2561 7.83489 13.4473 8.03377 13.6825 8.1584C13.9499 8.30009 14.2999 8.30009 15 8.30009H20.1632M13 20H5.5M15.5 14.8H5.5M20.5 10.8847V20.26C20.5 22.4442 20.5 23.5363 20.0913 24.3706C19.7317 25.1044 19.1581 25.701 18.4525 26.0749C17.6503 26.5 16.6002 26.5 14.5 26.5H6.5C4.3998 26.5 3.3497 26.5 2.54754 26.0749C1.84193 25.701 1.26825 25.1044 0.908726 24.3706C0.5 23.5363 0.5 22.4442 0.5 20.26V6.74C0.5 4.5558 0.5 3.46369 0.908726 2.62944C1.26825 1.8956 1.84193 1.29898 2.54754 0.925075C3.3497 0.5 4.3998 0.5 6.5 0.5H10.5147C11.4319 0.5 11.8905 0.5 12.3221 0.607757C12.7048 0.703295 13.0705 0.860871 13.4061 1.0747C13.7845 1.31589 14.1088 1.65314 14.7574 2.32765L18.7426 6.47235C19.3912 7.14686 19.7155 7.48411 19.9474 7.87769C20.153 8.22663 20.3045 8.60705 20.3964 9.005C20.5 9.45384 20.5 9.93079 20.5 10.8847Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NetAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 24, 27);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 24 27"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M20.9444 9.6C20.9444 14.6258 16.9399 18.7 12 18.7M20.9444 9.6C20.9444 4.57421 16.9399 0.5 12 0.5M20.9444 9.6H3.05556M12 18.7C7.06012 18.7 3.05556 14.6258 3.05556 9.6M12 18.7C14.2373 16.2081 15.5098 12.9742 15.5789 9.6C15.5098 6.22575 14.2373 2.9919 12 0.5M12 18.7C9.76274 16.2081 8.49248 12.9742 8.42339 9.6C8.49248 6.22575 9.76274 2.9919 12 0.5M12 18.7V21.3M3.05556 9.6C3.05556 4.57421 7.06012 0.5 12 0.5M14.5556 23.9C14.5556 25.3359 13.4114 26.5 12 26.5C10.5886 26.5 9.44444 25.3359 9.44444 23.9M14.5556 23.9C14.5556 22.4641 13.4114 21.3 12 21.3M14.5556 23.9H23.5M9.44444 23.9C9.44444 22.4641 10.5886 21.3 12 21.3M9.44444 23.9H0.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PcAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 21, 19);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 21 19"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M6.5 18.5H14.5M10.5 14.5V18.5M5.3 14.5H15.7C17.3802 14.5 18.2202 14.5 18.862 14.173C19.4265 13.8854 19.8854 13.4265 20.173 12.862C20.5 12.2202 20.5 11.3802 20.5 9.7V5.3C20.5 3.61984 20.5 2.77976 20.173 2.13803C19.8854 1.57354 19.4265 1.1146 18.862 0.82698C18.2202 0.5 17.3802 0.5 15.7 0.5H5.3C3.61984 0.5 2.77976 0.5 2.13803 0.82698C1.57354 1.1146 1.1146 1.57354 0.82698 2.13803C0.5 2.77976 0.5 3.61984 0.5 5.3V9.7C0.5 11.3802 0.5 12.2202 0.82698 12.862C1.1146 13.4265 1.57354 13.8854 2.13803 14.173C2.77976 14.5 3.61984 14.5 5.3 14.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PhoneAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 17, 31);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 17 31"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M3.75293 0.5H13.2471C15.0388 0.500173 16.4998 1.96874 16.5 3.79102V27.209C16.4998 29.0313 15.0388 30.4998 13.2471 30.5H3.75293C1.96122 30.4998 0.500188 29.0313 0.5 27.209V3.79102C0.500188 1.96874 1.96122 0.500173 3.75293 0.5Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function RedirectAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 19, 19);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M18.5 6.50001L18.5 0.50001M18.5 0.50001H12.5M18.5 0.50001L11.5 7.5M7.5 0.5H5.3C3.61984 0.5 2.77976 0.5 2.13803 0.82698C1.57354 1.1146 1.1146 1.57354 0.82698 2.13803C0.5 2.77976 0.5 3.61984 0.5 5.3V13.7C0.5 15.3802 0.5 16.2202 0.82698 16.862C1.1146 17.4265 1.57354 17.8854 2.13803 18.173C2.77976 18.5 3.61984 18.5 5.3 18.5H13.7C15.3802 18.5 16.2202 18.5 16.862 18.173C17.4265 17.8854 17.8854 17.4265 18.173 16.862C18.5 16.2202 18.5 15.3802 18.5 13.7V11.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SpeakAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 12, 27);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 12 27"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M11.2838 25.9839C10.8123 26.0755 10.2428 25.6676 10.2428 25.6676C7.76768 24.3802 6.2125 23.5572 4.83012 20.4965C1.90173 20.547 0.432429 16.6692 2.24916 14.7753C-1.46949 8.23793 1.14061 1.50803 6.33206 0.499312M7.9266 8.70578C5.09531 9.25591 3.38105 10.4195 3.84568 12.9094M7.35704 15.857L6.88508 15.9487"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SpeakAlert2Icon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 21, 29);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 21 29"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M14.0717 15.1252L14.1076 15.1028C15.7982 14.0417 16.757 13.4399 16.5848 12.645L12.9071 8.09446C11.703 5.3979 10.5483 3.52897 9.20368 2.31986M14.0717 15.1252C15.4115 14.3873 16.0522 15.3132 16.1354 15.8154L16.5513 18.3264M14.0717 15.1252L15.3196 22.6582M14.0717 15.1252C13.8222 13.6187 11.4506 14.0115 11.7002 15.5181L12.0329 17.5269M16.5513 18.3264C16.6929 16.239 18.6733 16.4269 18.9229 17.9335L20.0875 24.9643L19.7796 26.0473M16.5513 18.3264L17.3 22.8462M12.0329 17.5269L13.0312 23.5533M12.0329 17.5269C11.7001 15.5181 9.32858 15.9109 9.66134 17.9197L10.9092 25.4527C10.9092 25.4527 9.6278 23.6011 8.12167 23.3346C6.61553 23.0681 5.27578 23.806 5.83328 24.2296L8.87037 27.8544M7.54806 11.0461C8.98316 11.9364 9.71913 11.8942 10.8683 10.4961M0.500434 0.861995C4.49641 0.147916 7.08566 0.415274 9.20368 2.31986M9.20368 2.31986C8.52809 4.52907 7.77608 5.74722 5.06847 7.84499C3.50089 9.27289 3.00082 10.883 2.91293 15.4258"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}


/**
 * Composite "no talking" icon (two persons), like in your screenshot.
 *
 * Note: the red circle + diagonal is drawn by [`ProhibitedIcon`](app/assignments/quiz/[id]/components/AgreementPage.tsx:26),
 * so this icon only renders the black pictogram inside.
 */
export function SpeakAlertCombinedIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 48, 48);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}

      {/* Left person (shushing): speak_alert_2.svg, scaled up a bit */}
      <g transform="translate(4 7) scale(1.2)">
        <path
          d="M14.0717 15.1252L14.1076 15.1028C15.7982 14.0417 16.757 13.4399 16.5848 12.645L12.9071 8.09446C11.703 5.3979 10.5483 3.52897 9.20368 2.31986M14.0717 15.1252C15.4115 14.3873 16.0522 15.3132 16.1354 15.8154L16.5513 18.3264M14.0717 15.1252L15.3196 22.6582M14.0717 15.1252C13.8222 13.6187 11.4506 14.0115 11.7002 15.5181L12.0329 17.5269M16.5513 18.3264C16.6929 16.239 18.6733 16.4269 18.9229 17.9335L20.0875 24.9643L19.7796 26.0473M16.5513 18.3264L17.3 22.8462M12.0329 17.5269L13.0312 23.5533M12.0329 17.5269C11.7001 15.5181 9.32858 15.9109 9.66134 17.9197L10.9092 25.4527C10.9092 25.4527 9.6278 23.6011 8.12167 23.3346C6.61553 23.0681 5.27578 23.806 5.83328 24.2296L8.87037 27.8544M7.54806 11.0461C8.98316 11.9364 9.71913 11.8942 10.8683 10.4961M0.500434 0.861995C4.49641 0.147916 7.08566 0.415274 9.20368 2.31986M9.20368 2.31986C8.52809 4.52907 7.77608 5.74722 5.06847 7.84499C3.50089 9.27289 3.00082 10.883 2.91293 15.4258"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>

      {/* Right person (speaking): speak_alert.svg, mirrored to face left */}
      <g transform="translate(44 7) scale(-1.2 1.2)">
        <path
          d="M11.2838 25.9839C10.8123 26.0755 10.2428 25.6676 10.2428 25.6676C7.76768 24.3802 6.2125 23.5572 4.83012 20.4965C1.90173 20.547 0.432429 16.6692 2.24916 14.7753C-1.46949 8.23793 1.14061 1.50803 6.33206 0.499312M7.9266 8.70578C5.09531 9.25591 3.38105 10.4195 3.84568 12.9094M7.35704 15.857L6.88508 15.9487"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export function TabAlertIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 27, 21);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 27 21"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M0.5 12.375V18.0625C0.5 19.4087 1.63651 20.5 3.03846 20.5H19.9615C21.3635 20.5 22.5 19.4087 22.5 18.0625V12.375M0.5 12.375V9.9375C0.5 8.59131 1.63651 7.5 3.03846 7.5H19.9615C21.3635 7.5 22.5 8.59131 22.5 9.9375V12.375M0.5 12.375H22.5M23.9615 13.5C25.3635 13.5 26.5 12.4087 26.5 11.0625V5.375M26.5 5.375V2.9375C26.5 1.59131 25.3635 0.5 23.9615 0.5H7.03846C5.63651 0.5 4.5 1.59131 4.5 2.9375V5.375H26.5ZM4.73077 9.9375C4.73077 10.3862 4.35193 10.75 3.88462 10.75C3.4173 10.75 3.03846 10.3862 3.03846 9.9375C3.03846 9.48877 3.4173 9.125 3.88462 9.125C4.35193 9.125 4.73077 9.48877 4.73077 9.9375ZM8.11538 9.9375C8.11538 10.3862 7.73655 10.75 7.26923 10.75C6.80191 10.75 6.42308 10.3862 6.42308 9.9375C6.42308 9.48877 6.80191 9.125 7.26923 9.125C7.73655 9.125 8.11538 9.48877 8.11538 9.9375ZM11.5 9.9375C11.5 10.3862 11.1212 10.75 10.6538 10.75C10.1865 10.75 9.80769 10.3862 9.80769 9.9375C9.80769 9.48877 10.1865 9.125 10.6538 9.125C11.1212 9.125 11.5 9.48877 11.5 9.9375ZM8.73077 2.9375C8.73077 3.38623 8.35193 3.75 7.88462 3.75C7.4173 3.75 7.03846 3.38623 7.03846 2.9375C7.03846 2.48877 7.4173 2.125 7.88462 2.125C8.35193 2.125 8.73077 2.48877 8.73077 2.9375ZM12.1154 2.9375C12.1154 3.38623 11.7365 3.75 11.2692 3.75C10.8019 3.75 10.4231 3.38623 10.4231 2.9375C10.4231 2.48877 10.8019 2.125 11.2692 2.125C11.7365 2.125 12.1154 2.48877 12.1154 2.9375ZM15.5 2.9375C15.5 3.38623 15.1212 3.75 14.6538 3.75C14.1865 3.75 13.8077 3.38623 13.8077 2.9375C13.8077 2.48877 14.1865 2.125 14.6538 2.125C15.1212 2.125 15.5 2.48877 15.5 2.9375Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}